import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header/header1";
import bannerImg from "../../images/robotics-for-good/banner.png";
import { withTranslation } from "react-i18next";

class RoboticsForGoodIntroduction extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { t } = this.props;

    return (
      <>
        <Header />
        <div className="page-content">
          <div className="content-block" id="content-area">
            <div
              className="page-banner"
              style={{ backgroundImage: `url(${bannerImg})` }}
            >
              <div className="container">
                <div className="page-banner-entry">
                  <h1 className="text-white">
                    {t("Robotics_For_Good_Introduction_Title")}
                  </h1>
                </div>
              </div>
            </div>

            <div className="breadcrumb-row">
              <div className="container">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("Robotics_For_Good_Introduction_LinkHome")}</Link>
                  </li>
                  <li>{t("Robotics_For_Good_Introduction_Link")}</li>
                </ul>
              </div>
            </div>

            {/* 🌍 Robotics for Good Youth Challenge Section */}
            <div className="section-full content-inner bg-white m-t30">
              <div className="container">
                <div className="section-head style-1 text-center">
                  <h2 className="title">
                    About the Robotics for Good Youth Challenge
                  </h2>
                  <p>
                    The leading UN-based robotics competition for students aged
                    10–18, promoting innovation, sustainability, and global
                    citizenship.
                  </p>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <h4>🌍 Organized by the United Nations' ITU</h4>
                    <p>
                      The <strong>Robotics for Good Youth Challenge</strong> is
                      the leading UN-based global robotics competition,
                      organized by the International Telecommunication Union
                      (ITU) under the Robotics for Good Youth Challenge program. It invites students
                      aged 10–18 to design, build, and program robots that
                      tackle real-world challenges.
                    </p>
                    <p>
                      The <strong>2025–2026 edition</strong> focuses on{" "}
                      <strong>agriculture and food security</strong>, with
                      missions that reflect real agricultural processes and
                      sustainability goals.
                    </p>

                    <h4>🌱 Significance of the Challenge</h4>
                    <p>
                      This UN-based competition offers a unique entry point 
                      into STEM disciplines, while fostering teamwork, problem-solving, 
                      and innovation. By engaging in the Robotics for Good Youth Challenge, 
                      students not only enhance their technical expertise but also contribute 
                      to the UN’s Sustainable Development Goals (SDGs). It is a platform where 
                      education meets purpose, innovation meets responsibility, and young 
                      people gain the confidence to lead the digital future. 
                      Topics such as <strong>climate change</strong>,{" "}
                      <strong>food security</strong>, and{" "}
                      <strong>resource efficiency</strong> help prepare students
                      to become the next generation of innovators.
                    </p>

                    <h4>🤖 Competition Details</h4>
                    <ul>
                      <li>
                        <strong>Theme 2025–2026:</strong> Agriculture and Food
                        Systems
                      </li>
                      <li>🌱 Cultivation & Selective Irrigation</li>
                      <li>🍎 Harvesting & Sorting</li>
                    </ul>
                    <p>
                      Each match lasts <strong>2 minutes</strong>, during which
                      robots must operate <strong>fully autonomously</strong>.
                      These hands-on challenges provide students with essential
                      STEM experience and practical impact.
                    </p>

                    <h4>🇦🇺 Australian National Timeline</h4>
                    <ul>
                      <li>
                        🏅 <strong>State Team Selection:</strong> by end of
                        November 2025
                      </li>
                      <li>
                        🏟 <strong>National Competition:</strong> 28th March,
                        2026, Glenunga International High School (Adelaide)
                      </li>
                      <li>
                        🌍 <strong>Grand Finale:</strong> July 2026, Geneva,
                        Switzerland (self-funded travel)
                      </li>
                    </ul>

                    <h4>🏆 Benefits for Finalists</h4>
                    <p>
                      Winners of the Junior and Senior categories at the
                      Australian National Event will receive exclusive benefits
                      at the Robotics for Good Youth Challenge Global Summit 2026:
                    </p>
                    <ul>
                      <li>🎟 Grand Finale entry ticket</li>
                      <li>
                        🪑 Practice area with table, chairs, power, and premium
                        WiFi
                      </li>
                      <li>🍱 Lunch pack for each team member</li>
                      <li>🎫 General Summit Pass</li>
                      <li>
                        🤝 Networking with UN officials and international
                        partners
                      </li>
                      <li>🌍 Global media exposure</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* END Section */}
            <div className="section-full content-inner bg-light">
              <div className="container text-center">
                <div className="row justify-content-center">
                  <div className="col-md-4 mb-4">
                    <Link to="/robotics-for-good-application" className="btn btn-primary btn-lg w-100 shadow rounded-pill py-3">
                      🚀 Apply Now
                    </Link>
                  </div>
                  <div className="col-md-4 mb-4">
                    <Link to="/robotics-for-good-journey" className="btn btn-success btn-lg w-100 shadow rounded-pill py-3">
                      🌟 2025 - 2026 Journey
                    </Link>
                  </div>
                  <div className="col-md-4 mb-4">
                    <Link to="/robotics-for-good-partners" className="btn btn-warning btn-lg w-100 shadow rounded-pill py-3">
                      🤝 Become a Partner
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default RoboticsForGoodIntroduction = withTranslation()(RoboticsForGoodIntroduction);
